import isEmpty from 'lodash/isEmpty';

const LOCATION_BASE_URL = '/locations';

export const tabValues = {
  generalDetails: 'general_details',
  siteControllerStatus: 'site_controller_status',
  testingDashboard: 'testing_dashboard',
  scanData: 'scan_data',
  activityLog: 'activity_log',
  connectionHistory: 'connection_history',
};

export const routeCreator = {
  list: () => LOCATION_BASE_URL,
  create: () => `${LOCATION_BASE_URL}/create`,
  generalDetails: (id: string) => `${LOCATION_BASE_URL}/${id}`,
  generalDetailsUpdate: (id: string) =>
    `${LOCATION_BASE_URL}/${id}/${tabValues.generalDetails}/update`,
  siteControllerStatus: (id: string) =>
    `${LOCATION_BASE_URL}/${id}/${tabValues.siteControllerStatus}`,
  testingDashboard: (id: string) => `${LOCATION_BASE_URL}/${id}/${tabValues.testingDashboard}`,
  scanData: (id: string) => `${LOCATION_BASE_URL}/${id}/${tabValues.scanData}`,
  scanDataUpdate: (id: string) => `${LOCATION_BASE_URL}/${id}/${tabValues.scanData}/update`,
  activityLog: (id: string) => `${LOCATION_BASE_URL}/${id}/${tabValues.activityLog}`,
  connectionHistory: (id: string) => `${LOCATION_BASE_URL}/${id}/${tabValues.connectionHistory}`,
  locationGroupDetails: (locationGroupId: string) => `/location-groups/${locationGroupId}`,
};

const isNumeric = (value: string) => {
  return !isNaN(+value) && !isNaN(parseFloat(value));
};

export const isRequired = (value: any): string | undefined => {
  if (isEmpty(value)) {
    return 'This field is required';
  }

  return;
};

export const isFloat = (value = ''): string | undefined => {
  if (value && !isNumeric(value)) {
    return 'Value must be a valid number.';
  }

  return;
};
